/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskCommentResponseDto } from '../../models/core-project-subtask-comment-response-dto';
import { CoreProjectSubtaskCommentUpdateDto } from '../../models/core-project-subtask-comment-update-dto';

export interface ProjectSubtaskCommentsControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The comment ID.
 */
  id: string;
      body: CoreProjectSubtaskCommentUpdateDto
}

export function projectSubtaskCommentsControllerUpdate(http: HttpClient, rootUrl: string, params: ProjectSubtaskCommentsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtaskCommentsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>;
    })
  );
}

projectSubtaskCommentsControllerUpdate.PATH = '/o2-core/project-subtask-comments/{tenant}/{id}';
